export default "__VITE_ASSET__KgrAHpct__"